module.exports = __webpack_public_path__ + "img/task.e8af5b0c.jpg";